import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap styles
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Import Bootstrap JS (for tooltips to work)
import AuthUser from '../AuthUser';
const ViewMoreDetailsforBusinessQuotes = (props) => {
  const { http, getUser } = AuthUser()
  let userdetails = getUser()
  const [businessinfo, setBusinessinfo] = useState({})
  const [businessownerdata, setBusinessownerdata] = useState([])
  const [businessdetail, setBusinessdetail] = useState({})
  const [businesscoverage, setBusinesscoverage] = useState({})
  const [businessowner, setBusinessowner] = useState({})
  const [businesscommauto, setBusinesscommauto] = useState({})
  const [businesscommprop, setBusinesscommprop] = useState({})
  const [businesscyberliab, setBusinesscyberliab] = useState({})
  const [businessgeneralliab, setBusinessgeneralliab] = useState({})
  const [businessgrouphealth, setBusinessgrouphealth] = useState({})
  const [businessgrouplife, setBusinessgrouplife] = useState({})
  const [businessoceanmarine, setBusinessoceanmarine] = useState({})
  const [businessprofliab, setBusinessprofliab] = useState({})
  const [businessumbrella, setBusinessumbrella] = useState({})
  const [businessworker, setBusinessworker] = useState({})
  useEffect(() => {
    if (props.id) {
      http.get(`admin/viewBusiness/${userdetails.email}?id=${props.id}`)
        .then((response) => {
          console.log(response.data)
          setBusinessinfo(response.data.businessinfo)
          setBusinessownerdata(response.data.businessownerdata)
          setBusinessdetail(response.data.businessdetail)
          setBusinesscoverage(response.data.businesscoverage)
          setBusinessowner(response.data.businessowner)
          setBusinesscommauto(response.data.businesscommauto)
          setBusinesscommprop(response.data.businesscommprop)
          setBusinesscyberliab(response.data.businesscyberliab)
          setBusinessgeneralliab(response.data.businessgeneralliab)
          setBusinessgrouphealth(response.data.businessgrouphealth)
          setBusinessgrouplife(response.data.businessgrouplife)
          setBusinessoceanmarine(response.data.businessoceanmarine)
          setBusinessprofliab(response.data.businessprofliab)
          setBusinessumbrella(response.data.businessumbrella)
          setBusinessworker(response.data.businessworker)
        })
        .catch(function (error) {

        })
    }
  }, [props.id])


  return (
    <Container>      
      <Container className="m-auto">        
          <Container>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Basic Information
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Business Name</strong>
                </p>
                <span>{businessinfo.businessname}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Business Type</strong>
                </p>
                <span>{businessinfo.businesstype}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Industry </strong>
                </p>
                <span>{businessinfo.industry}</span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={6}>
                <p className="p-0 m-0">
                  <strong>Business Address</strong>
                </p>
                <span>{businessinfo.address}</span>
              </Col>
              <Col sm={6}>
                <p className="p-0 m-0">
                  <strong>City </strong>
                </p>
                <span>{businessinfo.city}</span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={6}>
                <p className="p-0 m-0">
                  <strong>State </strong>
                </p>
                <span>{businessinfo.state}</span>
              </Col>
              <Col sm={6}>
                <p className="p-0 m-0">
                  <strong>ZIP Code</strong>
                </p>
                <span>{businessinfo.zipcode}</span>
              </Col>
            </Row>
            <hr></hr>
            {businessownerdata.map((businessown, index) => (
            <>
              <Row className="mt-2 p-2">
                <Col sm={4}>
                  <p className="p-0 m-0">
                    <strong>Business Owner's Full Name</strong>
                  </p>
                  <span>{businessown.ownername}</span>
                </Col>
                <Col sm={4}>
                  <p className="p-0 m-0">
                    <strong>Percentage</strong>
                  </p>
                  <span>{businessown.percentage}%</span>
                </Col>
                <Col sm={4}>
                  <p className="p-0 m-0">
                    <strong>Email Address </strong>
                  </p>
                  <span>{businessown.businessemail}</span>
                </Col>
              </Row>
              <Row className="mt-2 p-2">
                <Col sm={4}>
                  <p className="p-0 m-0">
                    <strong>Phone Number </strong>
                  </p>
                  <span>{businessown.phoneno}</span>
                </Col>
              </Row>
            </>
            ))}
            <Row className="mt-2 p-2">
              <p className="fw-bold">Point of Contact (POC)</p>
              <hr></hr>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>First name</strong>
                </p>
                <span>{businessinfo.firstname}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Last name</strong>
                </p>
                <span>{businessinfo.lastname}</span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Designation </strong>
                </p>
                <span>{businessinfo.designation}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Email Address </strong>
                </p>
                <span>{businessinfo.email}</span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Phone Number </strong>
                </p>
                <span>{businessinfo.contactno}</span>
              </Col>
            </Row>

            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Business Details
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>

            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Number of Employees</strong>
                </p>
                <span>{businessdetail?.noofemp}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Annual Revenue</strong>
                </p>
                <span>${businessdetail?.annualrevenue}</span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Start Date</strong>
                </p>
                <span>{businessdetail?.startdate}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Years in Business</strong>
                </p>
                <span>{businessdetail?.years} years</span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Federal Tax ID/EIN</strong>
                </p>
                <span>{businessdetail?.federaltax}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Business License Number (if applicable)</strong>
                </p>
                <span>{businessdetail?.licenseno}</span>
              </Col>
            </Row>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Coverage Information
              </Col>
              <Col sm={1}>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Coverage Start Date</strong>
                </p>
                <span>{businesscoverage?.coveragedate}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Current Insurance Provider (if applicable)</strong>
                </p>
                <span>{businesscoverage?.inxprovider}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Annual Premium (if applicable)</strong>
                </p>
                <span>${businesscoverage?.annualpremium}</span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Previous Claims in Last 5 Years</strong>
                </p>
                <span>{businesscoverage?.claims}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Description of the claims</strong>
                </p>
                <span>{businesscoverage?.cliamdetails}</span>
              </Col>
            </Row>
            <br/>
            {businessowner && Object.keys(businessowner).length > 0 && (
              <>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Business Owners Policy (BOP)
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>

            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Square Footage of Premises</strong>
                </p>
                <span>{businessowner?.sqfoot} </span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Building Ownership</strong>
                </p>
                <span>{businessowner?.ownership}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Type of Building Construction</strong>
                </p>
                <span>{businessowner?.constructiontype} </span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Fire Safety Features</strong>
                </p>
                <span>{businessowner?.firesafety} </span>
              </Col>
            </Row>
            </>
            )} 
            {businesscommauto && Object.keys(businesscommauto).length > 0 && (
              <>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Commercial Auto Insurance
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>

            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Number of Vehicles</strong>
                </p>
                <span>{businesscommauto?.noofvehicles} </span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Make</strong>
                </p>
                <span>{businesscommauto?.make}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Model</strong>
                </p>
                <span>{businesscommauto?.model} </span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Year</strong>
                </p>
                <span>{businesscommauto?.year} </span>
              </Col>
              <Col sm={6}>
                <p className="p-0 m-0">
                  <strong>VIN</strong>
                </p>
                <span>{businesscommauto?.vin} </span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={12}>
                <p className="p-0 m-0">
                  <strong>License Number</strong>
                </p>
                <span>{businesscommauto?.licenseno} </span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Years of Experience</strong>
                </p>
                <span>{businesscommauto?.yearsofexp} </span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Vehicle Usage Details</strong>
                </p>
                <span>{businesscommauto?.usagedetails} </span>
              </Col>
            </Row>
            </>
            )}
            {businesscommprop && Object.keys(businesscommprop).length > 0 && (
              <>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Commercial Property Insurance
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>                  
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Property Value</strong>
                </p>
                <span>{businesscommprop?.propertyvalue} </span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Inventory Value</strong>
                </p>
                <span>{businesscommprop?.inventoryvalue}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Type of Equipment Used</strong>
                </p>
                <span>{businesscommprop?.equipmentused} </span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Security Measures</strong>
                </p>
                <span>{businesscommprop?.securitymeasures} </span>
              </Col>
            </Row>            
            </>
            )}
            {businesscyberliab && Object.keys(businesscyberliab).length > 0 && (
              <>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                  Cyber Liability Insurance
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>                  
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Annual Revenue from Online Operations</strong>
                </p>
                <span>{businesscyberliab?.annualrevenue} </span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Type of Data Stored</strong>
                </p>
                <span>{businesscyberliab?.datastored}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Current Cybersecurity Measures</strong>
                </p>
                <span>{businesscyberliab?.cybersecurity} </span>
              </Col>
            </Row>          
            </>
            )}
            {businessgeneralliab && Object.keys(businessgeneralliab).length > 0 && (
              <>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                General Liability Insurance
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>                  
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Estimated Annual Foot Traffic</strong>
                </p>
                <span>{businessgeneralliab?.anfoottraffic} </span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Nature of Risk Exposure</strong>
                </p>
                <span>{businessgeneralliab?.riskexpose}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Contracts with Vendors or Partners</strong>
                </p>
                <span>{businessgeneralliab?.vendorcontract} </span>
              </Col>
            </Row>          
            </>
            )}
            {businessgrouphealth && Object.keys(businessgrouphealth).length > 0 && (
              <>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Group Health Insurance
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>                  
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Number of Employees Eligible for Coverage</strong>
                </p>
                <span>{businessgrouphealth?.noofempelgibile} </span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Coverage Options Required</strong>
                </p>
                <span>{businessgrouphealth?.coverageoption}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Average Employee Age</strong>
                </p>
                <span>{businessgrouphealth?.avgempage} </span>
              </Col>
            </Row>          
            </>
            )}
            {businessgrouplife && Object.keys(businessgrouplife).length > 0 && (
              <>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Group Life Insurance
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>                  
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Number of Employees Eligible</strong>
                </p>
                <span>{businessgrouplife?.noofempelgibile} </span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Coverage Amount Per Employee</strong>
                </p>
                <span>{businessgrouplife?.coverageamtperemp}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Type of Plan</strong>
                </p>
                <span>{businessgrouplife?.plantype} </span>
              </Col>
            </Row>          
            </>
            )}
            {businessoceanmarine && Object.keys(businessoceanmarine).length > 0 && (
              <>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Ocean Marine Insurance
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>                  
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Type of Cargo Transported </strong>
                </p>
                <span>{businessoceanmarine?.typesofcargo} </span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Value of Cargo Per Shipment</strong>
                </p>
                <span>{businessoceanmarine?.valueofcargopership}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Frequency of Shipments</strong>
                </p>
                <span>{businessoceanmarine?.shipmentfreq} </span>
              </Col>
            </Row> 
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Routes/Regions Covered</strong>
                </p>
                <span>{businessoceanmarine?.routescovered} </span>
              </Col>
            </Row>          
            </>
            )}
            {businessprofliab && Object.keys(businessprofliab).length > 0 && (
              <>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Professional Liability (E&O)
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>                  
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Professional Services Offered</strong>
                </p>
                <span>{businessprofliab?.serviceoffered} </span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Annual Revenue from Services</strong>
                </p>
                <span>{businessprofliab?.annualrevenue}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>History of Complaints or Claims</strong>
                </p>
                <span>{businessprofliab?.claimhistory} </span>
              </Col>
            </Row>          
            </>
            )}
            {businessumbrella && Object.keys(businessumbrella).length > 0 && (
              <>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Umbrella Insurance
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>                  
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Primary Policies in Place</strong>
                </p>
                <span>{businessumbrella?.policyplace} </span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Coverage Limits of Primary Policies</strong>
                </p>
                <span>{businessumbrella?.coveragelimits}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Additional Coverage Needed</strong>
                </p>
                <span>{businessumbrella?.coverageneed} </span>
              </Col>
            </Row>          
            </>
            )}
            {businessworker && Object.keys(businessworker).length > 0 && (
              <>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Workers Compensation Insurance
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>                  
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Number of Employees by Job Role</strong>
                </p>
                <span>{businessworker?.empjobrole} </span>
              </Col>
              <Col sm={6}>
                <p className="p-0 m-0">
                  <strong>Job Descriptions and Associated Risks</strong>
                </p>
                <span>{businessworker?.riskassociated}</span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Payroll Details</strong>
                </p>
                <span>{businessworker?.payrolldetails} </span>
              </Col>
            </Row>          
            </>
            )}
          </Container>
      </Container>
    </Container>


  );


};

export default ViewMoreDetailsforBusinessQuotes;